var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandLogoLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 199.635,
    height: 56.278,
    viewBox: "0 0 199.635 56.278",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_4",
    "data-name": "Clip 4",
    d: "M0,0H10.411V31.553H0Z",
    transform: "translate(0.335 0.389)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_13",
    "data-name": "Clip 13",
    d: "M0,0H19.536V22.7H0Z",
    transform: "translate(0 0.313)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_46",
    "data-name": "Clip 46",
    d: "M0,0H13.6V14.325H0Z",
    transform: "translate(0.381 0.119)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Compraqui",
    "data-name": "Logo Compraqui",
    transform: "translate(0 -0.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M21.111.226,19.383,19.962a24.208,24.208,0,0,1-10.408,2.26c-6.687,0-9.381-3.3-8.926-8.49L1.231.226A13.433,13.433,0,0,1,3.87,0,11.752,11.752,0,0,1,6.382.226L5.33,12.241c-.305,3.477.428,5.419,4.721,5.419a11.676,11.676,0,0,0,4.455-.813L15.96.226A13,13,0,0,1,18.556,0a12.161,12.161,0,0,1,2.555.226",
    transform: "translate(166.667 10)",
    fill: "#ff8300"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(188.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_4-2",
    "data-name": "Clip 4",
    d: "M0,0H10.411V31.553H0Z",
    transform: "translate(0.335 0.389)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5-2",
    "data-name": "Group 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    "data-name": "Fill 3",
    d: "M2.723,31.553A13.561,13.561,0,0,1,0,31.321L1.988,9.372A14,14,0,0,1,4.75,9.14a12.618,12.618,0,0,1,2.673.232L5.436,31.321A12.944,12.944,0,0,1,2.723,31.553ZM3.856,7.326h0a2.512,2.512,0,0,1-1.51-1.907L7.117,0a4.979,4.979,0,0,1,3.294,4L3.856,7.326Z",
    transform: "translate(0.335 0.388)",
    fill: "#ff8300"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    d: "M17.311,28.889a11.781,11.781,0,0,1-2.549-.229l.575-6.552a11.945,11.945,0,0,1-4.565.823,11.167,11.167,0,0,1-8.411-3.213,10.088,10.088,0,0,1-2.3-7.932A12.614,12.614,0,0,1,4.356,3.1,13.259,13.259,0,0,1,13.013,0a13.532,13.532,0,0,1,9.209,3.244L19.943,28.66A12.764,12.764,0,0,1,17.311,28.889ZM12.65,4.659a7.167,7.167,0,0,0-7.346,6.9A6.253,6.253,0,0,0,6.7,16.469a6.116,6.116,0,0,0,4.667,1.8,10.124,10.124,0,0,0,4.437-.913l1.02-11.6A8.488,8.488,0,0,0,12.65,4.659Z",
    transform: "translate(143.333 8.889)",
    fill: "#ff8300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_8",
    "data-name": "Fill 8",
    d: "M9.688,23.333a9.576,9.576,0,0,1-7.177-3.009A10.609,10.609,0,0,1,.056,11.993a12.919,12.919,0,0,1,4.3-8.838A13.124,13.124,0,0,1,13.015,0a13.384,13.384,0,0,1,9.207,3.3L20.477,22.98a12.444,12.444,0,0,1-2.112.138,11.4,11.4,0,0,1-2.055-.138L16.062,20.8A8.973,8.973,0,0,1,9.688,23.333ZM12.652,4.74c-4.033,0-6.986,2.821-7.348,7.02a6.454,6.454,0,0,0,1.465,5.065A5.77,5.77,0,0,0,11.1,18.592c3.007,0,4.854-2.918,4.873-2.948l.845-9.787A8.369,8.369,0,0,0,12.652,4.74Z",
    transform: "translate(118.889 8.889)",
    fill: "#ff8300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_10",
    "data-name": "Fill 10",
    d: "M15.556.677A7.985,7.985,0,0,1,13.824,5.1a12.333,12.333,0,0,0-3.2-.406,8.7,8.7,0,0,0-4.074.857L5.12,22a12.287,12.287,0,0,1-2.58.226A12.017,12.017,0,0,1,0,22L1.647,3.071A15.14,15.14,0,0,1,10.9,0a13.018,13.018,0,0,1,4.657.677",
    transform: "translate(104.444 8.889)",
    fill: "#2c3d46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0 8.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_13-2",
    "data-name": "Clip 13",
    d: "M0,0H19.536V22.7H0Z",
    transform: "translate(0 0.313)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14-2",
    "data-name": "Group 14",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_12",
    "data-name": "Fill 12",
    d: "M.062,11.418A12.186,12.186,0,0,1,12.479,0a10.615,10.615,0,0,1,7.057,2.437,6.975,6.975,0,0,1-3.094,3.655,6.194,6.194,0,0,0-4.307-1.671c-4.229,0-6.51,3.207-6.841,6.952-.322,3.655,1.346,6.9,5.665,6.9a7.33,7.33,0,0,0,4.933-1.8,4.872,4.872,0,0,1,2.421,3.475A12.145,12.145,0,0,1,10.524,22.7C3.659,22.7-.567,18.55.062,11.418",
    transform: "translate(0 0.313)",
    fill: "#2c3d46"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_15",
    "data-name": "Fill 15",
    d: "M10.56,23.333a11.975,11.975,0,0,1-4.546-.842A9.432,9.432,0,0,1,2.59,20.13,9.562,9.562,0,0,1,.5,16.436,12.441,12.441,0,0,1,.055,11.69,12.565,12.565,0,0,1,12.779,0,11.893,11.893,0,0,1,17.31.843,9.448,9.448,0,0,1,20.726,3.2a9.629,9.629,0,0,1,2.1,3.717,12.493,12.493,0,0,1,.452,4.769A12.538,12.538,0,0,1,10.56,23.333ZM12.291,4.545c-3.851,0-6.584,2.8-6.962,7.145A6.836,6.836,0,0,0,6.81,17.051a5.564,5.564,0,0,0,4.242,1.69c3.851,0,6.58-2.768,6.954-7.051a7.057,7.057,0,0,0-1.5-5.459A5.527,5.527,0,0,0,12.291,4.545Z",
    transform: "translate(18.889 8.889)",
    fill: "#2c3d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_17",
    "data-name": "Fill 17",
    d: "M35.516,8.429,34.305,22a12.648,12.648,0,0,1-2.6.227,11.975,11.975,0,0,1-2.6-.227L30.184,9.962c.274-3.065-.908-5.273-4.449-5.273a7.982,7.982,0,0,0-4.8,1.712,9.923,9.923,0,0,1,.049,2.028L19.773,22a12.652,12.652,0,0,1-2.6.227A12.68,12.68,0,0,1,14.531,22L15.606,9.962c.274-3.065-.864-5.273-4.4-5.273a9.666,9.666,0,0,0-4.567,1.17L5.2,22a12.823,12.823,0,0,1-2.642.227A12.326,12.326,0,0,1,0,22L1.662,3.38A18.42,18.42,0,0,1,12.218,0c3.127,0,5.433.947,6.906,2.479A13.625,13.625,0,0,1,26.749,0c6.3,0,9.183,3.786,8.767,8.429",
    transform: "translate(43.333 8.889)",
    fill: "#2c3d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_19",
    "data-name": "Fill 19",
    d: "M2.64,28.889A12.882,12.882,0,0,1,0,28.658L2.239,3.369A17.045,17.045,0,0,1,12.386,0C16.041,0,19,1.116,20.928,3.228a8.83,8.83,0,0,1,1.949,3.507,12.82,12.82,0,0,1,.394,4.752,12.566,12.566,0,0,1-4.312,8.646,12.96,12.96,0,0,1-8.44,3.074,14.285,14.285,0,0,1-4.7-.646l-.539,6.1A12.527,12.527,0,0,1,2.64,28.889ZM11.728,4.8A9.38,9.38,0,0,0,7.293,5.859L6.249,17.67a9.392,9.392,0,0,0,4.309.878c4.11,0,7.008-2.734,7.384-6.966a6.283,6.283,0,0,0-1.4-4.939A6.3,6.3,0,0,0,11.728,4.8Z",
    transform: "translate(80 8.889)",
    fill: "#2c3d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_21",
    "data-name": "Fill 21",
    d: "M6.306,20a6.071,6.071,0,0,1-4.531-1.9A7.218,7.218,0,0,1,0,13.089,7.346,7.346,0,0,1,1.775,8.028,6.034,6.034,0,0,1,6.306,6.1a5.388,5.388,0,0,1,5.241,3.139V0h1.786V19.747H11.6l-.049-2.885a5.29,5.29,0,0,1-1.978,2.281A6.041,6.041,0,0,1,6.306,20ZM6.73,7.7c-2.9,0-4.842,2.168-4.842,5.394,0,3.194,1.946,5.341,4.842,5.341,2.881,0,4.817-2.157,4.817-5.367S9.611,7.7,6.73,7.7Z",
    transform: "translate(0 36.667)",
    fill: "#2c3d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_23",
    "data-name": "Fill 23",
    d: "M6.185,14.444C2.485,14.444,0,11.537,0,7.209A7.933,7.933,0,0,1,1.684,1.986,5.65,5.65,0,0,1,6.136,0a5.64,5.64,0,0,1,4.408,1.937,7.679,7.679,0,0,1,1.677,5.115c0,.23,0,.658-.024.868H1.883c.226,3.129,1.834,5,4.3,5a5.054,5.054,0,0,0,4.179-2.367l1.345.816A6.314,6.314,0,0,1,6.185,14.444ZM6.136,1.527c-2.452,0-4.082,1.935-4.253,5.051h8.505C10.241,3.463,8.613,1.527,6.136,1.527Z",
    transform: "translate(17.778 42.222)",
    fill: "#2c3d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_25",
    "data-name": "Fill 25",
    d: "M7.357,18.889H0V0H6.9c3.334,0,5.574,1.918,5.574,4.772A4.42,4.42,0,0,1,9.465,9.009a4.657,4.657,0,0,1,3.868,4.622,4.916,4.916,0,0,1-1.642,3.816A6.44,6.44,0,0,1,7.357,18.889ZM1.909,10.005v7.274H7.157c2.508,0,4.193-1.466,4.193-3.649s-1.685-3.625-4.193-3.625Zm0-8.4V8.371H6.5C8.892,8.371,10.5,7.017,10.5,5S8.851,1.608,6.4,1.608Z",
    transform: "translate(41.111 36.667)",
    fill: "#2c3d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_27",
    "data-name": "Fill 27",
    d: "M4.374,14.444a4.569,4.569,0,0,1-3.168-1.108A3.878,3.878,0,0,1,0,10.394C0,7.86,2.182,6.157,5.43,6.157A16.463,16.463,0,0,1,9.3,6.63V5.658c0-2.547-1.523-4.129-3.974-4.129A4.666,4.666,0,0,0,1.684,3.078L.855,1.922A6.485,6.485,0,0,1,5.757,0,5.311,5.311,0,0,1,9.65,1.486,5.455,5.455,0,0,1,11.111,5.42v8.761H9.351L9.3,11.262A5.316,5.316,0,0,1,4.374,14.444ZM5.657,7.527c-2.256,0-3.771,1.13-3.771,2.813,0,1.655,1.146,2.684,2.991,2.684,2.176,0,4.426-1.889,4.426-5.05A15.783,15.783,0,0,0,5.657,7.527Z",
    transform: "translate(56.667 42.222)",
    fill: "#2c3d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_29",
    "data-name": "Fill 29",
    d: "M12.222,5.1v8.238H10.385V5.443c0-2.349-1.71-3.884-4.261-3.884-2.578,0-4.287,1.535-4.287,3.884v7.891H0V.247H1.786l.026,2.2A5.255,5.255,0,0,1,6.686,0C10,0,12.222,2.029,12.222,5.1",
    transform: "translate(71.111 42.222)",
    fill: "#2c3d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_31",
    "data-name": "Fill 31",
    d: "M0,7.208A6.836,6.836,0,0,1,7.243,0,7.08,7.08,0,0,1,11.8,1.526L10.706,2.843A5.215,5.215,0,0,0,7.243,1.657c-3.141,0-5.218,2.211-5.218,5.579,0,3.339,2.1,5.575,5.245,5.575a5.309,5.309,0,0,0,3.835-1.5l1.118,1.29a7.255,7.255,0,0,1-5.085,1.843C2.876,14.444,0,11.55,0,7.208",
    transform: "translate(86.667 42.222)",
    fill: "#2c3d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_33",
    "data-name": "Fill 33",
    d: "M6.692,14.444c-4,0-6.692-2.9-6.692-7.208C0,2.908,2.689,0,6.692,0c3.973,0,6.642,2.908,6.642,7.236C13.333,11.547,10.664,14.444,6.692,14.444Zm0-12.785c-2.879,0-4.814,2.241-4.814,5.577s1.935,5.576,4.814,5.576c2.85,0,4.765-2.241,4.765-5.576S9.541,1.659,6.692,1.659Z",
    transform: "translate(100 42.222)",
    fill: "#2c3d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_35",
    "data-name": "Fill 35",
    d: "M12.222,17.28v1.609H0V0H11.986V1.61H2V8.45h9.33v1.608H2V17.28Z",
    transform: "translate(117.778 36.667)",
    fill: "#2c3d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_37",
    "data-name": "Fill 37",
    d: "M.027,12.97l.786-1.183a6.588,6.588,0,0,0,3.979,1.13c1.962,0,3.271-.919,3.271-2.341,0-1.315-1.229-2.05-2.9-2.525L3.664,7.606C1.493,7,0,6.132,0,4.053,0,1.608,1.938,0,4.869,0A8.317,8.317,0,0,1,9.581,1.266L8.769,2.554A6.9,6.9,0,0,0,5,1.529c-1.832,0-3.063.868-3.063,2.236,0,1.288,1.073,1.868,2.564,2.288L6,6.5c2.093.578,4,1.631,4,3.919,0,2.421-2.017,4.025-5.208,4.025A7.131,7.131,0,0,1,.027,12.97",
    transform: "translate(132.222 42.222)",
    fill: "#2c3d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_39",
    "data-name": "Fill 39",
    d: "M8.889,15.7v1.513a7.679,7.679,0,0,1-3.134.563,3.446,3.446,0,0,1-3.5-3.739V5.507H0V3.97H2.252V0H4.016V3.97H8.693V5.507H4.016v8.172a2.289,2.289,0,0,0,2.277,2.509,6.865,6.865,0,0,0,2.6-.485",
    transform: "translate(144.444 38.889)",
    fill: "#2c3d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_41",
    "data-name": "Fill 41",
    d: "M4.374,14.444a4.569,4.569,0,0,1-3.168-1.108A3.878,3.878,0,0,1,0,10.394C0,7.86,2.182,6.157,5.43,6.157A16.463,16.463,0,0,1,9.3,6.63V5.658c0-2.547-1.523-4.129-3.974-4.129A4.665,4.665,0,0,0,1.684,3.078L.854,1.922A6.489,6.489,0,0,1,5.757,0,5.311,5.311,0,0,1,9.65,1.486,5.455,5.455,0,0,1,11.111,5.42v8.761H9.351L9.3,11.262A5.316,5.316,0,0,1,4.374,14.444ZM5.656,7.527c-2.256,0-3.771,1.13-3.771,2.813,0,1.655,1.146,2.684,2.991,2.684,2.176,0,4.427-1.889,4.427-5.05A15.81,15.81,0,0,0,5.656,7.527Z",
    transform: "translate(154.444 42.222)",
    fill: "#2c3d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_43",
    "data-name": "Fill 43",
    d: "M6.306,20a6.071,6.071,0,0,1-4.531-1.9A7.218,7.218,0,0,1,0,13.089,7.346,7.346,0,0,1,1.775,8.028,6.034,6.034,0,0,1,6.306,6.1a5.384,5.384,0,0,1,5.239,3.139V0h1.788V19.747H11.6l-.05-2.885A5.386,5.386,0,0,1,6.306,20ZM6.73,7.7c-2.9,0-4.842,2.168-4.842,5.394,0,3.194,1.946,5.341,4.842,5.341,2.88,0,4.815-2.157,4.815-5.367S9.61,7.7,6.73,7.7Z",
    transform: "translate(168.889 36.667)",
    fill: "#2c3d46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(185.556 42.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_46-2",
    "data-name": "Clip 46",
    d: "M0,0H13.6V14.325H0Z",
    transform: "translate(0.381 0.119)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47-2",
    "data-name": "Group 47",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_45",
    "data-name": "Fill 45",
    d: "M6.827,14.324C2.744,14.324,0,11.452,0,7.177,0,2.884,2.744,0,6.827,0,10.88,0,13.6,2.884,13.6,7.177,13.6,11.452,10.88,14.324,6.827,14.324Zm0-12.679c-2.938,0-4.912,2.223-4.912,5.531s1.974,5.53,4.912,5.53c2.907,0,4.86-2.222,4.86-5.53S9.734,1.645,6.827,1.645Z",
    transform: "translate(0.381 0.119)",
    fill: "#2c3d46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogoLogin);
export default __webpack_public_path__ + "static/media/brand-logo-login.db109bceee6f4b51f8c6ef62e7c20f0a.svg";
export { ForwardRef as ReactComponent };